module.exports = __webpack_public_path__ + "img/logo-white-small.e66c141e.svg";